import React from 'react';
import { components, NoticeProps } from 'react-select';

import { DepartureOption } from '@lt/api/dist/types/departure';

export const LoadingMessage = (props: NoticeProps<DepartureOption, false>) => (
  <components.NoOptionsMessage {...props}>
    <span>Загрузка городов...</span>
  </components.NoOptionsMessage>
);
